import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerTicketSummary, GameService, GameDataSource, config, TicketQuery } from '@fgb/core';
import { DateTime } from 'luxon';

@Component({
  selector: 'fgbcl-ticket-transfer-game-panel',
  templateUrl: './ticket-transfer-game-panel.component.html',
  styleUrls: ['./ticket-transfer-game-panel.component.scss'],
})
export class TicketTransferGamePanelComponent implements OnInit {
  @Input() customerTicketSummary: CustomerTicketSummary;
  windowStartDate: Date;
  windowEndDate: Date;
  availableTransfers: boolean = true;
  pastGame: boolean = false;
  config: any = config;
  homeTeamLogoUrl: string;
  awayTeamLogoUrl: string;
  ticketDetails: any;

  constructor(private gameService: GameService, private router: Router, private ticketQuery: TicketQuery) {}

  ngOnInit(): void {
    let currentDate = new Date();
    this.ticketDetails = this.ticketQuery.getTicketInformation(this.customerTicketSummary.GameNumber);
    if (this.ticketDetails.TicketsAvailableToTransfer === 0 && this.ticketDetails.TicketsTransferred === 0) {
      this.availableTransfers = false;
    }

    if (DateTime.fromISO(this.customerTicketSummary.Date as string, { zone: 'utc' }).endOf('day') < DateTime.fromJSDate(currentDate, { zone: 'utc' }).endOf('day')) {
      this.pastGame = true;
    }
    this.homeTeamLogoUrl = this.getTeamLogoUrl(this.customerTicketSummary.HomeTeamId);
    this.awayTeamLogoUrl = this.getTeamLogoUrl(this.customerTicketSummary.AwayTeamId);
  }

  selectGame(customerTicketSummary: CustomerTicketSummary) {
    this.gameService.fetchGamesAndSetActiveGame(customerTicketSummary.GameNumber, GameDataSource.ExternalRef);
    this.router.navigate(['ticketTransfer/tickets/' + customerTicketSummary.GameNumber]);
  }

  getTeamLogoUrl(teamId: number) {
    return `${this.config.contentUrl}/image/teams/${teamId}__1_1_1033.png`;
  }
}
